import { EventName, EvId, Params } from '../types';

const evIdParams: Record<EventName, { params?: Params }> = {
  settings_panel_open_connect_account_old_users: {
    params: {
      evid: EvId.settingPanelOpen,
      page_name: 'old_users_page',
    },
  },
  settings_panel_open_manage_account_not_connected: {
    params: {
      evid: EvId.settingPanelOpen,
      page_name: 'manage_account_not_connected',
    },
  },

  settings_panel_open_manage_waiting_for_approval: {
    params: {
      evid: EvId.settingPanelOpen,
      page_name: 'manage_waiting_for_approval',
    },
  },
  settings_panel_open_manage_account_connected_ad_not_connected: {
    params: {
      evid: EvId.settingPanelOpen,
      page_name: 'manage_account_connected_ad_not_connected',
    },
  },
  settings_panel_open_manage_account_connected_ad_not_created: {
    params: {
      evid: EvId.settingPanelOpen,
      page_name: 'manage_account_connected_ad_not_created',
    },
  },
  settings_panel_open_manage_account_connected_ad_connected: {
    params: {
      evid: EvId.settingPanelOpen,
      page_name: 'manage_account_connected_ad_connected',
    },
  },

  settings_panel_open_ads_tab_no_ads_created: {
    params: {
      evid: EvId.settingPanelOpen,
      page_name: 'ads_tab_no_ads_created',
    },
  },
  settings_panel_open_ads_tab_fixed_ad: {
    params: { evid: EvId.settingPanelOpen, page_name: 'ads_tab_fixed_ad' },
  },
  settings_panel_open_ads_tab_responsive_ad: {
    params: { evid: EvId.settingPanelOpen, page_name: 'ads_tab_responsive_ad' },
  },
  settings_panel_open_ads_tab_no_ads_connected: {
    params: {
      evid: EvId.settingPanelOpen,
      page_name: 'ads_tab_no_ads_connected',
    },
  },
  settings_panel_open_support_tab: {
    params: {
      evid: EvId.settingPanelOpen,
      page_name: 'support_tab',
    },
  },
  click_button_support_tab_see_all_articles: {
    params: {
      evid: EvId.button,
      origin: 'support_tab',
      description: 'see_all_articles',
    },
  },
  click_button_support_tab_wix_assitant: {
    params: {
      evid: EvId.button,
      origin: 'support_tab',
      description: 'wix_assitant',
    },
  },
  click_button_support_tab_adsense_help: {
    params: {
      evid: EvId.button,
      origin: 'support_tab',
      description: 'adsense_help',
    },
  },
  click_button_support_tab_contact_customer_care: {
    params: {
      evid: EvId.button,
      origin: 'support_tab',
      description: 'contact_customer_care',
    },
  },
  click_button_connect_account_old_users: {
    params: {
      evid: EvId.button,
      origin: 'old_users_page',
      description: 'connect_account',
    },
  },
  click_button_manage_account_not_connected: {
    params: {
      evid: EvId.button,
      origin: 'manage_account_not_connected',
      description: 'go_to_dashboard',
    },
  },
  click_button_manage_waiting_for_approval: {
    params: {
      evid: EvId.button,
      origin: 'manage_waiting_for_approval',
      description: 'go_to_dashboard',
    },
  },
  click_button_manage_account_connected_ad_not_connected_connect_ad_unit: {
    params: {
      evid: EvId.button,
      origin: 'manage_account_connected_ad_not_connected',
      description: 'connect_ad_unit',
    },
  },
  click_button_manage_account_connected_ad_not_connected_manage_ads: {
    params: {
      evid: EvId.button,
      origin: 'manage_account_connected_ad_not_connected',
      description: 'manage_ads',
    },
  },
  click_button_manage_account_connected_ad_not_created_create_ad_unit: {
    params: {
      evid: EvId.button,
      origin: 'manage_account_connected_ad_not_created',
      description: 'create_ad_unit',
    },
  },
  click_button_manage_account_connected_ad_not_created_manage_ads: {
    params: {
      evid: EvId.button,
      origin: 'manage_account_connected_ad_not_created',
      description: 'manage_ads',
    },
  },
  click_button_manage_account_connected_ad_connected: {
    params: {
      evid: EvId.button,
      origin: 'manage_account_connected_ad_connected',
      description: 'manage_ads',
    },
  },
  click_button_manage_account_connected_ad_connected_duplicate_ad: {
    params: {
      evid: EvId.button,
      origin: 'manage_account_connected_ad_connected',
      description: 'duplicate_ad',
    },
  },

  click_button_ads_tab_no_ads_created: {
    params: {
      evid: EvId.button,
      origin: 'ads_tab_no_ads_created',
      description: 'new_ad_unit',
    },
  },
  click_button_ads_tab_fixed_ad: {
    params: {
      evid: EvId.button,
      origin: 'ads_tab_fixed_ad',
      description: 'new_ad_unit',
    },
  },
  click_button_ads_tab_responsive_ad: {
    params: {
      evid: EvId.button,
      origin: 'ads_tab_responsive_ad',
      description: 'new_ad_unit',
    },
  },
  click_button_ads_tab_no_ads_connected: {
    params: {
      evid: EvId.button,
      origin: 'ads_tab_no_ads_connected',
      description: 'new_ad_unit',
    },
  },

  live_site_ad_view: {
    params: {
      evid: EvId.adView,
    },
  },
  live_site_ad_click: {
    params: {
      // need to update evid,
    },
  },
  '': {},
};

export default evIdParams;
